<template>
    <Modal v-model="seedFarmFormShow" title="苗场信息" width="60">
        <div class="global-tool-bar">
            <div class="left-bar"></div>
            <div class="right-bar" style="margin-bottom: 20px">
                <Button type="success" @click="doPrint">打印订购告知书</Button>
            </div>
        </div>
        <Form
            ref="seedFarmForm"
            :model="seedFarmForm"
            :rules="ruleValidate"
            label-position="top"
        >
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="种苗场编号" prop="seedFarmCode">
                        <Input
                            v-model="seedFarmForm.seedFarmCode"
                            :disabled="
                                seedFarmForm.formEditMode !==
                                FORM_EDIT_MODE_CREATE
                            "
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="种苗场名称" prop="seedFarmName">
                        <Input v-model="seedFarmForm.seedFarmName"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="所属区域" prop="seedFarmAreaUuid">
                        <Select
                            v-model="seedFarmForm.seedFarmAreaUuid"
                            filterable
                        >
                            <Option
                                v-for="item in areaSource"
                                :key="item.areaUuid"
                                :value="item.areaUuid"
                                >{{ item.areaName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="省份" prop="seedFarmProvince">
                        <Select
                            v-model="seedFarmForm.seedFarmProvince"
                            filterable
                            clearable
                            placeholder="请选择省"
                            @on-change="onProvinceChange"
                        >
                            <Option
                                v-for="item in provinceOptions"
                                :key="item.regionUuid"
                                :value="item.regionUuid"
                                >{{ item.regionName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="城市" prop="seedFarmCity">
                        <Select
                            v-model="seedFarmForm.seedFarmCity"
                            filterable
                            clearable
                            placeholder="请选择市"
                            @on-change="onCityChange"
                        >
                            <Option
                                v-for="item in cityOptions"
                                :key="item.regionUuid"
                                :value="item.regionUuid"
                                >{{ item.regionName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="区/县" prop="seedFarmDist">
                        <Select
                            v-model="seedFarmForm.seedFarmDist"
                            filterable
                            clearable
                            placeholder="请选择区/县"
                        >
                            <Option
                                v-for="item in distOptions"
                                :key="item.regionUuid"
                                :value="item.regionUuid"
                                >{{ item.regionName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="地址">
                        <Input v-model="seedFarmForm.seedFarmAddress"></Input>
                    </FormItem>
                </Col>

                <Col span="6">
                    <FormItem label="联系人">
                        <Input v-model="seedFarmForm.seedFarmContact"></Input>
                    </FormItem>
                </Col>

                <Col span="6">
                    <FormItem label="联系电话" prop="seedFarmContactPhone">
                        <Input
                            v-model="seedFarmForm.seedFarmContactPhone"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="品牌名称" prop="brandName">
                        <Input v-model="seedFarmForm.brandName"></Input>
                    </FormItem>
                </Col>

                <Col span="6">
                    <FormItem label="用友部门" prop="ysDeptCode">
                        <Select
                            v-model="seedFarmForm.ysDeptCode"
                            clearable
                            filterable
                            @on-select="onSelectYSDept"
                        >
                            <Option
                                v-for="item in YSDeptOptions"
                                :key="item.code"
                                :value="item.code"
                                >{{ item.code }} - {{ item.name }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="默认转运站">
                        <Select
                            v-model="seedFarmForm.defaultDtbStationsUuid"
                            clearable
                            filterable
                        >
                            <Option
                                v-for="(item, index) in distributionStationsOptions"
                                :key="index"
                                :value="item.id"
                                >{{ item.code }} - {{ item.name }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>

                <Col span="24">
                    <FormItem label="种苗定购告知书" prop="noticeContent">
                        <Input
                            id="printContent"
                            v-model="seedFarmForm.noticeContent"
                            :rows="30"
                            type="textarea"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem label="示范视频">
                        <template>
                            <Upload
                                action="https://up-z2.qiniup.com/"
                                :data="uploadParams"
                                :format="['mp4']"
                                accept=".mp4"
                                :on-format-error="handleFormatError"
                                :on-success="handleUploadVideoSuccess"
                                :before-upload="beforeVideoUpload"
                                :show-upload-list="showUploadList"
                                v-if="
                                    readOnly == false && demonVideos.length < 5
                                "
                            >
                                <Button icon="ios-cloud-upload-outline">上传视频</Button
                                >
                            </Upload>

                            <Row :gutter="16" style="margin-top: 10px">
                                <Col
                                    span="5"
                                    v-for="(item, index) in demonVideos"
                                    :key="index"
                                >
                                    <div class="img-card">
                                        <video
                                            width="150"
                                            height="150"
                                            controls
                                        >
                                            <source
                                                :src="item.src"
                                                type="video/mp4"
                                            />
                                        </video>
                                        <Icon
                                            type="md-trash"
                                            class="icon-delete"
                                            @click="deleteVideo(index)"
                                            v-if="readOnly == false"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </template>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button
                type="primary"
                @click="onSave"
                v-if="$checkAccessArray(['S', 'B', 'C'])"
                >确认</Button
            >
            <Button type="error" @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { qiniuToken } from '@/api/modules/product-management/product-management';
import { getSeedFarmList, saveSeedFarm } from '@/api/modules/system-management/seedFarm-management';
import search from "@/libs/search";
const initialSeedFarmForm = {
    formEditMode: "",
    seedFarmUuid: "",
    seedFarmCode: "",
    seedFarmName: "",
    seedFarmAddress: "",
    seedFarmAreaUuid: "",
    seedFarmProvince: "",
    seedFarmCity: "",
    seedFarmDist: "",
    seedFarmRelateWarehouseUuid: "",
    seedFarmContact: "",
    seedFarmContactPhone: "",
    brandVarietyName: "",
    brandName: "",
    brandCode: "",
    brandMainImageFile: "",
    brandThumbnailFile: "",
    noticeContent: "",
    ysDeptId: "",
    ysDeptCode: "",
    ysDeptName: "",
    defaultDtbStationsUuid: "",
    demoVideo: ""
};
export default {
    name: "SeedFarmModal",
    props: {
        readOnly: { type: Boolean, default: false },
        YSDeptOptions: { type: Array, default: [] },
        distributionStationsOptions: { type: Array, default: [] },
        allRegions: { type: Array, default: [] },
        areaSource: { type: Array, default: [] }
    },
    data() {
        return {
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            innerSpin: false,
            seedFarmFormShow: false,
            showUploadList: false,
            seedFarmForm: { ...initialSeedFarmForm },
            ruleValidate: {
                seedFarmCode: [{ required: true, message: '种苗场编号不能为空', trigger: 'blur' }],
                seedFarmName: [{ required: true, message: '种苗场名称不能为空', trigger: 'blur' }],
                seedFarmAreaUuid: [{ required: true, message: '请选择所属区域', trigger: 'change' }],
                seedFarmProvince: [{ required: true, message: '请选择省份', trigger: 'change' }],
                seedFarmCity: [{ required: true, message: '请选择城市', trigger: 'change' }],
                seedFarmDist: [{ required: true, message: '请选择区/县', trigger: 'change' }],
                brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                seedFarmContactPhone: [
                    { required: true, message: '联系电话不能为空', trigger: 'blur' },
                    { pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
                ]
            },
            demonVideos: [],
            uploadParams: {}
        };
    },
    mounted() {
        
    },
    computed: {
        
        // 省份选项
        provinceOptions() {
            return this.allRegions.filter((r) => r.regionType === 1);
        },

        // 城市选项
        cityOptions() {
            if (!this.seedFarmForm.seedFarmProvince) return [];
            return this.allRegions.filter(
                (r) => r.regionType === 2 && r.regionParentUuid === this.seedFarmForm.seedFarmProvince
            );
        },

        // 区/县选项
        distOptions() {
            if (!this.seedFarmForm.seedFarmCity) return [];
            return this.allRegions.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === this.seedFarmForm.seedFarmCity
            );
        }
    },
    methods: {
        doPrint() {
            printJS({
                printable: "printContent",
                type: "html",
                targetStyles: ["padding-top"],
                maxWidth: 1920
            });
        },
        init() {
            this.seedFarmForm = {
                formEditMode: "",
                seedFarmUuid: "",
                seedFarmCode: "",
                seedFarmName: "",
                seedFarmAddress: "",
                seedFarmAreaUuid: "",
                seedFarmProvince: "",
                seedFarmCity: "",
                seedFarmDist: "",
                seedFarmRelateWarehouseUuid: "",
                seedFarmContact: "",
                seedFarmContactPhone: "",
                brandVarietyName: "",
                brandCode: "",
                brandName: "",
                brandMainImageFile: "",
                brandThumbnailFile: "",
                noticeContent: "",
                ysDeptId: "",
                ysDeptCode: "",
                ysDeptName: "",
                defaultDtbStationsUuid: ""
            };
        },
        async showModal(formEditMode, seedFarmUuid = null) {
            this.seedFarmFormShow = true;
            this.demonVideos = [];
            this.$nextTick(() => {
                this.$refs.seedFarmForm.resetFields();
            });

            this.seedFarmForm.formEditMode = formEditMode;

            if (this.isCreateMode) {
                this.resetForm();
            }
            else {
                await this.loadSeedFarmModel(seedFarmUuid);
            }
        },
        resetForm() {
            this.seedFarmForm = { ...initialSeedFarmForm, formEditMode: this.FORM_EDIT_MODE_CREATE };
        },
        async loadSeedFarmModel(uuid) {
            this.innerSpin = true;
            try {
                const temp = search.getSearchParams();
                temp.limit.enable = false;
                search.globalAddFilterConditionKey(temp, "seedFarmUuid", "eq", uuid);
                const res = await getSeedFarmList(temp);
                if (res.code === 0 && res.data && res.data.records && res.data.records.length > 0) {
                    this.resetForm();
                    const formData = res.data.records[0];
                    console.log("formData", formData);
                    this.seedFarmForm = { ...this.seedFarmForm, ...formData };
                    console.log("this.seedFarmForm", this.seedFarmForm);
                    if (formData.demoVideo) {
                        this.demonVideos = formData.demoVideo.split(',').map(key => ({
                            id: key,
                            src: this.imageDomain + key
                        }));
                    }
                }
                else {
                    this.$Message.error("获取苗场信息失败！");
                    this.seedFarmFormShow = false;
                }
            }
            catch (error) {
                this.$Message.error("加载数据时发生错误。");
            }
            finally {
                this.innerSpin = false;
            }
        },
        
        onSave() {
            this.$refs.seedFarmForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败，请检查填写内容!");
                    return;
                }
                const videoKeys = this.demonVideos.map(item => item.src.replace(this.imageDomain, ''));
                const dataToSave = {
                    ...this.seedFarmForm,
                    demoVideo: videoKeys.join(','),
                    deptType: 1
                };

                saveSeedFarm(dataToSave).then((res) => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.seedFarmFormShow = false;
                                this.$emit('refresh');
                            }
                        });
                    }
                });
            });
        },
        
        onCancel() {
            this.seedFarmFormShow = false;
        },
        
        handleFormatError() {
            this.$Notice.warning({ title: '格式错误', desc: '请上传mp4格式文件' });
        },
        async beforeVideoUpload(file) {
            try {
                const suffix = file.name.substring(file.name.lastIndexOf('.'));
                const filename = `video_${Date.now()}${Math.random().toString(36).slice(2)}${suffix}`;
                const res = await qiniuToken({});
                this.uploadParams.token = res.data.token;
                this.uploadParams.key = filename;
            }
            catch (error) {
                this.$Message.error("获取上传凭证失败！");
                return Promise.reject(error);
            }
        },
        handleUploadVideoSuccess(res, file) {
            let videoKey = res.key;
            this.demonVideos.push({ id: videoKey, src: this.imageDomain + videoKey, size: file.size });
        },
        deleteVideo(index) {
            this.$Modal.confirm({
                title: "确认",
                content: "是否删除此视频？",
                onOk: () => {
                    this.demonVideos.splice(index, 1);
                }
            });
        },
        onProvinceChange() {
            this.seedFarmForm.seedFarmCity = "";
            this.seedFarmForm.seedFarmDist = "";
        },
        onCityChange() {
            this.seedFarmForm.seedFarmDist = "";
        },
        onSelectYSDept(value) {
            const matchedDept = this.YSDeptOptions.find(item => item.code === value);
            if (matchedDept) {
                this.seedFarmForm.ysDeptId = matchedDept.id;
                this.seedFarmForm.ysDeptName = matchedDept.name;
            }
        }
    }
};
</script>

<style scoped>
.img-card {
    position: relative;
    margin-bottom: 10px;
}

.icon-delete {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    color: #ff4d4f;
}
</style>
